var React = require('react');

function AxeBattle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 160.92C505.16 99.16 478.4 44.29 438.94 4.7c-9.21-9.25-23.89-4.12-27.06 9-12 49.67-47.25 88.27-91.88 101.23v154.18c44.63 13 79.85 51.56 91.88 101.23 3.17 13.08 17.85 18.21 27.06 9 39.46-39.59 66.22-94.45 73.06-156.22L449.24 192zM101 13.66C97.86.58 83.32-4.54 74.2 4.7 28.67 50.83 0 117.62 0 192s28.67 141.17 74.2 187.3c9.13 9.25 23.66 4.12 26.8-9 11.92-49.67 46.79-88.27 91-101.23V114.89c-44.21-12.96-79.08-51.56-91-101.23z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M288 80v416a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16z","className":"fa-primary","key":2})]);
}

AxeBattle.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = AxeBattle;

AxeBattle.default = AxeBattle;
